/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { useAuth } from '../../modules/auth'
import { toast } from 'react-toastify'

const DashboardPage = (props) => {
    const { isAgent, isAdmin } = useAuth()

    return (
        <>
            {/* begin::Row */}
            <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                <div className="row gy-5 g-xl-10">
                    <div className="col-xl-6">
                        <div className="card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow">
                            <div className="card-body d-flex flex-column">
                                <div className="d-flex flex-column flex-grow-1">
                                    <Link to="/leads" className="text-dark text-hover-theme fw-bolder fs-3 mb-4">
                                        Total Leads
                                    </Link>

                                    <div className="mt-5">
                                        <span className="text-dark fw-bolder fs-3x me-2 lh-0">
                                            {props.stats?.totalLeads}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6">
                        <div className="card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow">
                            <div className="card-body d-flex flex-column">
                                <div className="d-flex flex-column flex-grow-1">
                                    <Link to="/leads" className="text-dark text-hover-theme fw-bolder fs-3 mb-4">
                                        Total New Leads
                                    </Link>

                                    <div className="mt-5">
                                        <span className="text-dark fw-bolder fs-3x me-2 lh-0">
                                            {props.stats?.newLeads}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isAgent && (
                        <>
                            {isAdmin && (
                                <div className="col-xl-6">
                                    <div className="card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow">
                                        <div className="card-body d-flex flex-column">
                                            <div className="d-flex flex-column flex-grow-1">
                                                <Link
                                                    to="/users"
                                                    className="text-dark text-hover-theme fw-bolder fs-3 mb-4"
                                                >
                                                    Total Staff
                                                </Link>

                                                <div className="mt-5">
                                                    <span className="text-dark fw-bolder fs-3x me-2 lh-0">
                                                        {props.stats?.totalStaff}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="col-xl-6">
                                <div className="card card-xl-stretch mb-xl-10 theme-dark-bg-body shadow">
                                    <div className="card-body d-flex flex-column">
                                        <div className="d-flex flex-column flex-grow-1">
                                            <Link
                                                to="/blogs"
                                                className="text-dark text-hover-theme fw-bolder fs-3 mb-4"
                                            >
                                                Total Blogs
                                            </Link>

                                            <div className="mt-5">
                                                <span className="text-dark fw-bolder fs-3x me-2 lh-0">
                                                    {props.stats?.totalBlogs}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

const DashboardWrapper = () => {
    const intl = useIntl()
    const { isAdmin } = useAuth()
    const [stats, setStats] = useState({})
    const [syncing, setSyncing] = useState(false)

    useEffect(() => {
        const token = localStorage.getItem('kt-auth-react-v.api_token')
        axios
            .get(`${process.env.REACT_APP_API_URL}/adminuser/dashboard-stats`, {
                headers: { Authorization: ` ${token}` },
            })
            .then((res) => {
                setStats(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])

    const handleSyncProperties = async () => {
        if (!isAdmin) {
            toast.error('You do not have permission to sync properties.')
            return
        }
        setSyncing(true)
        const token = localStorage.getItem('kt-auth-react-v.api_token')
        try {
            // call sync API (adjust endpoint if needed)
            const { data } = await axios.post(
                `${process.env.REACT_APP_API_URL}/properties/sync`,
                {},
                { headers: { Authorization: `Bearer ${token}` } },
            )
            toast.success(data.message || 'Properties synced successfully.')
        } catch (err) {
            console.error('Sync properties failed', err)
        } finally {
            setSyncing(false)
        }
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between w-100">
                <div className="me-auto">
                    <h3 className="card-title align-items-start flex-column text-dark">
                        <span className="card-label fw-bold fs-3 mb-1">
                            {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
                        </span>
                    </h3>
                </div>

                {isAdmin && (
                    <button
                        type="button"
                        className="btn btn-sm btn-dark ms-3"
                        onClick={handleSyncProperties}
                        disabled={syncing}
                    >
                        {syncing && (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                        )}
                        {syncing ? 'Syncing...' : 'Sync Properties'}
                    </button>
                )}
            </div>

            <DashboardPage stats={stats} />
        </>
    )
}

export { DashboardWrapper }
